import { useEffect, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { post } from 'helpers/apiHelpers';
import { fetchDiets } from 'actions/Diets';
import { fetchVariants } from 'actions/Variants';
import { combineStyles } from 'helpers/helpers';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { withTranslation } from 'react-i18next';
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from 'react-toastify';

import FormMassActionsView from './FormMassActions.view';
import { rootDefaultState, mappingDefaultState } from '../defaultState';

const FormMassActionsContainer = ({
  t,
  classes,
  diets,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiets,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchVariants,
  history,
  variants,
}) => {
  const [state, setState] = useState({
    ...rootDefaultState,
    isSubmitting: false,
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps, require-await -- FIXME
  useEffect(async () => {
    setState(prev => ({ ...prev, isLoading: true }));
    fetchDiets();
    fetchVariants();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const selectAllergens = ({ target: { value } }) =>
    setState(prev => ({ ...prev, selectedAllergens: value }));

  const selectIngredientCategories = ({ target: { value } }) =>
    setState(prev => ({ ...prev, selectedIngredientCategories: value }));

  const handleInputChange = (event, value) => {
    const newValue = event.target.value;
    setState(prev => ({
      ...prev,
      [event.target.name]: value || newValue,
    }));
  };

  const fillDefaultsMargins = marginName => {
    if (state[marginName] === '') {
      setState(prev => ({ ...prev, [marginName]: 5 }));
    }
  };

  const handleToggle = name => {
    setState(prev => ({ ...prev, [name]: !state[name] }));
  };

  const handleChangeDate = async (event, field) => {
    await setState(prevState => ({
      ...prevState,
      [field]: event.format('YYYY-MM-DD'),
    }));
  };

  const confirmModal = () => {
    setState(prev => ({
      ...prev,
      alert: (
        <SweetAlert
          warning={true}
          title={t('common.shared.areYouSure')}
          onConfirm={() => {
            // eslint-disable-next-line no-use-before-define -- FIXME
            onSave();
            // eslint-disable-next-line no-use-before-define -- FIXME
            hideAlert();
          }}
          // eslint-disable-next-line no-use-before-define -- FIXME
          onCancel={() => hideAlert()}
          confirmBtnCssClass={`${classes.button} ${classes.success}`}
          cancelBtnCssClass={`${classes.button} ${classes.danger}`}
          confirmBtnText={t('common.shared.yes')}
          cancelBtnText={t('common.shared.no')}
          showCancel={true}
        />
      ),
    }));
  };

  // eslint-disable-next-line consistent-return -- FIXME
  const handleSubmit = () => {
    if (!state.applyToAllActiveDiets) {
      if (!state.dateFrom || !state.dateTo) {
        return toast.error(t('massAction.dietElements.validation.dates'));
      }
    }

    confirmModal();
  };

  const onSave = () => {
    const data = {
      dateFrom: state.applyToAllActiveDiets ? null : state.dateFrom,
      dateTo: state.applyToAllActiveDiets ? null : state.dateTo,
      applyToAllActiveDiets: state.applyToAllActiveDiets,
      updateDietDefaults: state.updateDietDefaults,
      updateBags: state.updateBags,
      updateSubscriptions: state.updateSubscriptions,
      updateSubscriptionIntents:
        state.updateSubscriptionIntents && !state.resetSubscriptionIntents,
      resetSubscriptionIntents: state.resetSubscriptionIntents,
      mapping: state.mapping.map(el => ({
        from: {
          diet: el.from.diet?.['@id'] ?? null,
          variant: el.from.variant?.['@id'] ?? null,
          calorific: el.from.calorific?.['@id'] ?? null,
        },
        to: {
          diet: el.to.diet?.['@id'] ?? null,
          variant: el.to.variant?.['@id'] ?? null,
          calorific: el.to.calorific?.['@id'] ?? null,
        },
      })),
    };
    setState(prev => ({ ...prev, isSubmitting: true }));

    const action = post('/diet-elements-configurations', data);

    action
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        history.push('/admin/mass-actions-diet-elements');
        setState(prev => ({ ...prev, isSubmitting: false }));
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => setState(prev => ({ ...prev, isSubmitting: false })));
  };

  const hideAlert = () => {
    setState(prev => ({ ...prev, alert: null }));
  };

  const addMappingRow = () => {
    setState(prevState => ({
      ...prevState,
      mapping: [...prevState.mapping, { ...mappingDefaultState() }],
    }));
  };

  // eslint-disable-next-line @typescript-eslint/max-params -- FIXME
  const handleDiets = (type, index, e, selected) => {
    const mappings = [...state.mapping];

    mappings[index][type].diet = selected;
    setState(prevState => ({
      ...prevState,
      mapping: [...mappings],
    }));
  };

  // eslint-disable-next-line @typescript-eslint/max-params -- FIXME
  const handleVariants = (type, index, e, selected) => {
    const mappings = [...state.mapping];

    mappings[index][type].variant = selected;
    setState(prevState => ({
      ...prevState,
      mapping: [...mappings],
    }));
  };
  // eslint-disable-next-line @typescript-eslint/max-params -- FIXME
  const handleCalorific = (type, index, e, selected) => {
    const mappings = [...state.mapping];

    mappings[index][type].calorific = selected;
    setState(prevState => ({
      ...prevState,
      mapping: [...mappings],
    }));
  };

  const getDietVariants = diet =>
    variants.filter(el => el.diets.includes(diet['@id']));

  const getCountRowsWithDiet = diet =>
    state.mapping.filter(el => el.from.diet?.['@id'] === diet['@id']).length;

  const getCountRowsWithVariant = variant =>
    state.mapping.filter(el => el.from.variant?.['@id'] === variant['@id'])
      .length;

  const getCountRowsWithVariantAndDiet = (diet, variant) =>
    state.mapping.filter(
      el =>
        el.from.diet?.['@id'] === diet['@id'] &&
        el.from.variant?.['@id'] === variant['@id']
    ).length;

  const fillVariants = (index, diet) => {
    const variantsToFill = getDietVariants(diet);

    const newMapping = [...state.mapping];
    const currentRow = newMapping.splice(index, 1)[0];

    variantsToFill.forEach((el, vIndex) => {
      newMapping.splice(index + vIndex, 0, {
        from: {
          diet,
          variant: el,
          calorific: null,
        },
        to: {
          diet: currentRow.to.diet,
          variant: currentRow.to.variant,
          calorific: currentRow.to.calorific,
        },
      });
    });

    setState(prevState => ({
      ...prevState,
      mapping: newMapping,
    }));
  };

  const fillVariantCalories = (index, diet, variant) => {
    const newMapping = [...state.mapping];
    const currentRow = newMapping.splice(index, 1)[0];

    variant.calories.forEach((el, vIndex) => {
      newMapping.splice(index + vIndex, 0, {
        from: {
          diet,
          variant,
          calorific: el,
        },
        to: {
          diet: currentRow.to.diet,
          variant: currentRow.to.variant,
          calorific: currentRow.to.calorific,
        },
      });
    });

    setState(prevState => ({
      ...prevState,
      mapping: newMapping,
    }));
  };

  const removeRow = index => {
    const newMapping = [...state.mapping];
    newMapping.splice(index, 1);

    setState(prevState => ({
      ...prevState,
      mapping: newMapping,
    }));
  };

  const props = {
    t,
    classes,
    diets,
    fetchDiets,
    fetchVariants,
    history,
    variants,
    state,
    setState,
    selectAllergens,
    selectIngredientCategories,
    handleInputChange,
    fillDefaultsMargins,
    handleToggle,
    handleChangeDate,
    confirmModal,
    handleSubmit,
    onSave,
    hideAlert,
    addMappingRow,
    handleDiets,
    handleVariants,
    handleCalorific,
    getDietVariants,
    getCountRowsWithDiet,
    getCountRowsWithVariant,
    getCountRowsWithVariantAndDiet,
    fillVariants,
    fillVariantCalories,
    removeRow,
  };
  return <FormMassActionsView props={props} />;
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const mapStateToProps = state => ({
  diets: state.Diets.diets,
  variants: state.Variants.variants,
});

export default withTranslation()(
  connect(mapStateToProps, {
    fetchDiets,
    fetchVariants,
  })(withStyles(combinedStyles)(FormMassActionsContainer))
);
